import "VSS/LoaderPlugins/Css!Agile/Scripts/Backlog/ContextMenu/Components/ChangeParentDialog";

import React = require("react");
import { Fabric } from "OfficeFabric/Fabric";
import * as Dialog from "OfficeFabric/Dialog";
import * as Button from "OfficeFabric/Button";
import * as AgileResources from "Agile/Scripts/Resources/TFS.Resources.Agile";

export interface ISimpleMessageDialogProps {
    title: string;
    message: string;
    onDismiss: () => void;
    link?: ISimpleMessageLink; // Link to be appended to message
}

export interface ISimpleMessageLink {
    linkText: string;
    url: string;
}

export class SimpleMessageDialog extends React.Component<ISimpleMessageDialogProps, null> {
    public render(): JSX.Element {
        const dialogProps: Dialog.IDialogProps = {
            isOpen: true,
            type: Dialog.DialogType.close,
            isBlocking: true,
            title: this.props.title,
            containerClassName: "change-parent-simple-message-dialog",
            onDismiss: () => this.props.onDismiss()
        };

        return (
            <Fabric>
                <Dialog.Dialog {...dialogProps}>
                    {this.props.message}
                    {this.props.link ? <a href={this.props.link.url}>{this.props.link.linkText}</a> : null}
                    <Dialog.DialogFooter>
                        <Button.PrimaryButton onClick={() => this.props.onDismiss()}>{AgileResources.Close}</Button.PrimaryButton>
                    </Dialog.DialogFooter>
                </Dialog.Dialog>
            </Fabric>
        );
    }
}